var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"page"}},[_c('router-view')],1),_c('spinner',{attrs:{"loading":_vm.LoadingStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }